import type { ApiClient } from "./client";

export interface SlackChannelMapping {
  channel_id: string;
  channel_name: string;
}

/** Where the OAuth callback should send the user back to. */
export type OAuthReturn = "onboarding" | "settings";

export const integrationsApi = (client: ApiClient) => ({
  google: {
    status: () => client.get<{ connected: boolean }>("/api/v1/integrations/google/status"),
    connect: (ret?: OAuthReturn) =>
      client.get<{ authorization_url: string }>(
        `/api/v1/integrations/google/connect${ret === "onboarding" ? "?return=onboarding" : ""}`,
      ),
    disconnect: () => client.post<void>("/api/v1/integrations/google/disconnect"),
  },
  slack: {
    status: (tenantId: string) =>
      client.get<{ connected: boolean }>(
        `/api/v1/integrations/slack/status?tenant_id=${encodeURIComponent(tenantId)}`,
      ),
    install: (tenantId: string, ret?: OAuthReturn) =>
      client.get<{ authorization_url: string }>(
        `/api/v1/integrations/slack/install?tenant_id=${encodeURIComponent(tenantId)}${ret === "onboarding" ? "&return=onboarding" : ""}`,
      ),
    disconnect: (tenantId: string) =>
      client.post<void>("/api/v1/integrations/slack/disconnect", { tenant_id: tenantId }),
    getChannel: (tenantId: string) =>
      client.get<{ channel: SlackChannelMapping | null }>(
        `/api/v1/tenants/${tenantId}/integrations/slack/channel`,
      ),
    putChannel: (tenantId: string, body: SlackChannelMapping) =>
      client.request<{ channel: SlackChannelMapping }>(
        `/api/v1/tenants/${tenantId}/integrations/slack/channel`,
        { method: "PUT", body: JSON.stringify(body) },
      ),
  },
});
